export const SET_BOOKING_INFO = 'SET_BOOKING_INFO'
